<template>
    <b-card
        v-if="mode"
        :title="translations[`${mode}LoyaltyProgram`][lang]"
        @cancel="$emit('close')"
        @submit="submitForm"
        :error-message="errorMessage"
        :loading="loading"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
    >
        <b-text-field
            v-model="loyaltyProgram.name[nameLang]"
            :label="translations.name[lang]"
            :success="nameLang === 'el' ? success.name : false"
            :error-messages="error.name"
            @focus="error.name = ''"
            @blur="validateName"
        >
            <template v-slot:append>
                <b-lang-menu v-model="nameLang" type="inner"></b-lang-menu>
            </template>
        </b-text-field>

        <b-textarea
            v-model="loyaltyProgram.description[descriptionLang]"
            :label="translations.description[lang]"
            :success="descriptionLang === 'el' ? success.description : false"
            :error-messages="error.description"
            @focus="error.description = ''"
            @blur="validateDescription"
        >
            <template v-slot:append>
                <b-lang-menu
                    v-model="descriptionLang"
                    type="inner"
                ></b-lang-menu>
            </template>
        </b-textarea>
        <b-text-field
            v-model="loyaltyProgram.points_label"
            :label="translations.pointsLabel[lang]"
            :success="success.points_label"
            :error-messages="error.points_label"
            @focus="error.points_label = ''"
            @blur="validatePointsLabel"
        >
        </b-text-field>
        <v-card outlined class="mt-3">
            <v-card-title class="subtitle-1 font-weight-medium">
                Logo
            </v-card-title>
            <v-row no-gutters justify="space-between" class="pa-5">
                <v-col cols="6">
                    <v-img :src="logo.image"></v-img>
                </v-col>
                <v-col cols="5" class="mr-3">
                    <v-file-input
                        v-model="logo.name"
                        color="secondary"
                        outlined
                        dense
                        hide-details="auto"
                        @change="onFileSelected"
                        :success="success.logo"
                        :error-messages="error.logo"
                        @focus="error.logo = ''"
                    ></v-file-input>
                </v-col>
            </v-row>
        </v-card>
        <v-checkbox
            v-model="loyaltyProgram.active"
            color="secondary"
            class="mt-3 pt-0"
            hide-details="auto"
            v-if="mode === 'create'"
        >
            <template v-slot:label>
                <h4 class="secondary--text">
                    {{ translations.activateOnCreate[lang] }}
                </h4>
            </template>
        </v-checkbox>
    </b-card>
</template>

<script>
import { mdiPlus } from "@mdi/js";
import { mapMutations, mapState, mapActions } from "vuex";
import validators from "@/utils/validators/loyaltyPanel/loyaltyProgram";
import translations from "@/utils/translations/loyaltyPanel/loyaltyPrograms";

export default {
    name: "LoyaltyCardForm",

    mixins: [validators, translations],

    props: {
        mode: {
            type: String,
            default: "create"
        }
    },

    data() {
        return {
            icons: {
                mdiPlus
            },
            nameLang: this.$route.params.lang,
            changeNameElAuto: true,
            changeNameItAuto: true,
            changeNameEnAuto: true,
            descriptionLang: this.$route.params.lang,
            changeDescriptionElAuto: true,
            changeDescriptionItAuto: true,
            changeDescriptionEnAuto: true,
            logo: {
                image: null,
                file: null,
                name: ""
            }
        };
    },
    computed: {
        ...mapState(["loading", "errorMessage", "activeCountries"]),
        ...mapState("loyaltyPanel", ["company"]),

        lang() {
            return this.$route.params.lang;
        },
        loyaltyProgram: {
            get() {
                return this.$store.state.loyaltyPanel.loyaltyPrograms
                    .loyaltyProgram;
            },

            set(val) {
                this.setLoyaltyProgram(val);
            }
        }
    },
    methods: {
        ...mapActions("loyaltyPanel/loyaltyPrograms", [
            "createLoyaltyProgram",
            "updateLoyaltyProgram",
            "uploadLoyaltyProgramLogo"
        ]),
        ...mapMutations("loyaltyPanel/loyaltyPrograms", ["setLoyaltyProgram"]),
        ...mapMutations(["setNotification"]),
        ...mapActions(["loadActiveCountries"]),

        onFileSelected(event) {
            if (event) {
                this.logo.file = event;
                const reader = new FileReader();
                reader.readAsDataURL(this.logo.file);
                reader.onload = e => {
                    this.logo.image = e.target.result;
                    this.validateLogo();
                };
            }
        },
        closeModal() {
            this.loyaltyProgram = {};
            this.logo = {
                image: null,
                file: null,
                name: null
            };
            this.$emit("close");
        },
        async submitForm() {
            this.validateForm();
            if (!this.formValid) {
                return this.setNotification({
                    show: true,
                    type: "error",
                    text: this.translations.checkForm[this.lang]
                });
            }
            await this[`${this.mode}LoyaltyProgram`](this.logo.file);
            this.closeModal();
        }
    },
    mounted() {
        this.loadActiveCountries();
        this.logo.image = this.loyaltyProgram.logo || null;
    },
    watch: {
        ["loyaltyProgram.name.en"](val) {
            if (this.lang == "en") {
                if (this.changeNameElAuto) {
                    this.loyaltyProgram.name.el = val;
                }

                if (this.changeNameItAuto) {
                    this.loyaltyProgram.name.it = val;
                }

                this.changeNameEnAuto = false;
            } else if (val != this.loyaltyProgram.name[this.lang]) {
                this.changeNameEnAuto = false;
            }
        },

        ["loyaltyProgram.name.el"](val) {
            if (this.lang == "el") {
                if (this.changeNameEnAuto) {
                    this.loyaltyProgram.name.en = val;
                }

                if (this.changeNameItAuto) {
                    this.loyaltyProgram.name.it = val;
                }

                this.changeNameElAuto = false;
            } else if (val != this.loyaltyProgram.name[this.lang]) {
                this.changeNameElAuto = false;
            }
        },

        ["loyaltyProgram.name.it"](val) {
            if (this.lang == "it") {
                if (this.changeNameElAuto) {
                    this.loyaltyProgram.name.el = val;
                }

                if (this.changeNameEnAuto) {
                    this.loyaltyProgram.name.en = val;
                }

                this.changeNameItAuto = false;
            } else if (val != this.loyaltyProgram.name[this.lang]) {
                this.changeNameItAuto = false;
            }
        },

        ["loyaltyProgram.description.en"](val) {
            if (this.lang == "en") {
                if (this.changeDescriptionElAuto) {
                    this.loyaltyProgram.description.el = val;
                }

                if (this.changeDescriptionItAuto) {
                    this.loyaltyProgram.description.it = val;
                }

                this.changeDescriptionEnAuto = false;
            } else if (val != this.loyaltyProgram.description[this.lang]) {
                this.changeDescriptionEnAuto = false;
            }
        },

        ["loyaltyProgram.description.el"](val) {
            if (this.lang == "el") {
                if (this.changeDescriptionEnAuto) {
                    this.loyaltyProgram.description.en = val;
                }

                if (this.changeDescriptionItAuto) {
                    this.loyaltyProgram.description.it = val;
                }

                this.changeDescriptionElAuto = false;
            } else if (val != this.loyaltyProgram.description[this.lang]) {
                this.changeDescriptionElAuto = false;
            }
        },

        ["loyaltyProgram.description.it"](val) {
            if (this.lang == "it") {
                if (this.changeDescriptionElAuto) {
                    this.loyaltyProgram.description.el = val;
                }

                if (this.changeDescriptionEnAuto) {
                    this.loyaltyProgram.description.en = val;
                }

                this.changeDescriptionItAuto = false;
            } else if (val != this.loyaltyProgram.description[this.lang]) {
                this.changeDescriptionItAuto = false;
            }
        },
        ["logo.image"](val, prev) {
            if (val || prev) {
                this.validateLogo();
            }
        },
        ["loyaltyProgram.country_id"]: {
            async handler(val) {
                console.log(val, "country", this.company?.country?.country_id);
                if (!val) {
                    this.loyaltyProgram.country_id = this.company?.country?.country_id;
                }
            },
            immediate: true
        },

        ["loyaltyProgram.logo"]: {
            async handler(val) {
                if (!val) {
                    this.logo = {
                        image: null,
                        file: null,
                        name: null
                    };
                } else {
                    this.logo = {
                        image: val,
                        file: null,
                        name: null
                    };
                }
            },
            immediate: true
        }
    }
};
</script>
